import type { AssetTimelineItemCardProps } from "./asset-timeline-item-card.type";

import { Icon } from "@mdi/react";
import { Card, Flex, Typography } from "antd";

import { format } from "@/utilities/date";

import { AssetTimelineItemDetails } from "../asset-timeline-item-details";

const { Title, Text } = Typography;

export const AssetTimelineItemCard = ({ item }: AssetTimelineItemCardProps) => {
  const { title, date, color, icon } = item;

  return (
    <Card
      title={
        <Flex align="center" gap="small">
          {icon ? <Icon path={icon} size="20px" color={color} /> : null}
          <Title level={3}>{title}</Title>
        </Flex>
      }
      classNames={{
        root: "asset-timeline-item-card",
        header: "asset-timeline-item-card--header",
        body: "asset-timeline-item-card--body",
      }}
    >
      <Text>{format(date)}</Text>
      <AssetTimelineItemDetails item={item} />
    </Card>
  );
};
